import { datadogRum } from '@datadog/browser-rum'

const FIRST_PARTY_DOMAINS = ['weathernews.jp']
const EXCLUDE_DOMAINS = ['']

const isDomainMatch = (hostname, domains) =>
  domains.some((domain) => hostname === domain || hostname.endsWith(`.${domain}`))

const isFirstPartyUrl = (url) => {
  try {
    const { hostname } = new URL(url)

    if (isDomainMatch(hostname, EXCLUDE_DOMAINS)) {
      return false
    }

    return isDomainMatch(hostname, FIRST_PARTY_DOMAINS)
  } catch {
    return false
  }
}

export const initDatadog = () => {
  const config = useRuntimeConfig()
  datadogRum.init({
    applicationId: '98fb0e3e-1c03-4e15-b060-3a3dd1643c4e',
    clientToken: 'pub600da0078f88438d524a7f0ea0b396de',
    site: 'ap1.datadoghq.com',
    service: 'onebox-wind',
    env: config.public.env,
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: config.public.env === 'development' ? 100 : 0.1,
    sessionReplaySampleRate: config.public.env === 'development' ? 100 : 10,
    trackBfcacheViews: true,
    defaultPrivacyLevel: 'mask-user-input',
    excludedActivityUrls: [
      (url) => !isFirstPartyUrl(url)
    ]
  })

  let userId = useCookie('datadogUserId').value
  if (!userId) {
    userId = crypto.randomUUID()
    useCookie('datadogUserId', {
      maxAge: 60 * 60 * 24 * 400 // 400 days
    }).value = userId
  }
  datadogRum.setUser({ id: userId })
}
